/* 2026-07-31-mobile-play */
(function () {
  'use strict';

  function isMobileHero() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function connectionAllowsVideo() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return true;
    if (conn.saveData) return false;
    if (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') return false;
    return true;
  }

  /** Prefer SD → 720 → anything; HD-1080 is last resort. */
  function sourceScore(url) {
    var u = (url || '').toLowerCase();
    if (u.indexOf('sd-480') !== -1 || u.indexOf('480p') !== -1) return 0;
    if (u.indexOf('720') !== -1) return 1;
    if (u.indexOf('1080') !== -1) return 9;
    return 2;
  }

  /**
   * Shopify often exposes only HD in Liquid sources. Rewrite to SD sibling when possible.
   * Pattern: {hash}.HD-1080p-{bitrate}-{id}.mp4 → {hash}.SD-480p-1.2Mbps-{id}.mp4
   */
  function toLightUrl(url) {
    if (!url) return url;
    var m = url.match(/\.HD-\d+p-.+?-(\d+)\.mp4/i);
    if (m) {
      return url.replace(/\.HD-\d+p-.+?\.mp4/i, '.SD-480p-1.2Mbps-' + m[1] + '.mp4');
    }
    return url;
  }

  function pickSource(video) {
    var sources = Array.prototype.slice.call(video.querySelectorAll('source[data-src]'));
    if (!sources.length) return null;
    sources.sort(function (a, b) {
      return sourceScore(a.getAttribute('data-src')) - sourceScore(b.getAttribute('data-src'));
    });
    return sources[0];
  }

  function markPlaying(bg) {
    if (bg) bg.classList.add('is-video-playing');
  }

  function tryPlay(bg, video) {
    video.muted = true;
    video.defaultMuted = true;
    try { video.volume = 0; } catch (e) {}
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
    video.controls = false;
    video.removeAttribute('controls');
    var playPromise = video.play();
    if (playPromise && playPromise.then) {
      playPromise.then(function () { markPlaying(bg); }).catch(function () {});
    } else if (!video.paused) {
      markPlaying(bg);
    }
  }

  function loadAndPlay(bg, video) {
    var chosen = pickSource(video);
    if (!chosen) return;

    var raw = chosen.getAttribute('data-src');
    var light = toLightUrl(raw);

    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.removeAttribute('src');
    });

    // Prefer rewritten light URL; fall back to raw if SD 404s.
    chosen.src = light;
    video.preload = isMobileHero() ? 'auto' : 'metadata';

    var fallbackTried = false;
    video.addEventListener('error', function onErr() {
      if (fallbackTried || light === raw) return;
      fallbackTried = true;
      chosen.src = raw;
      video.load();
      tryPlay(bg, video);
    });

    video.load();

    video.addEventListener('playing', function () { markPlaying(bg); }, { once: true });
    ['loadeddata', 'canplay'].forEach(function (eventName) {
      video.addEventListener(eventName, function handler() {
        tryPlay(bg, video);
        video.removeEventListener(eventName, handler);
      });
    });
    tryPlay(bg, video);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && video.paused) tryPlay(bg, video);
    });
    window.addEventListener('pageshow', function () {
      if (video.paused) tryPlay(bg, video);
    });
    // iOS often needs a user gesture if autoplay is blocked first pass.
    document.addEventListener('touchstart', function () {
      if (video.paused) tryPlay(bg, video);
    }, { once: true, passive: true });
  }

  function scheduleLoad(bg, video) {
    var run = function () { loadAndPlay(bg, video); };
    // Mobile: start sooner so the poster does not linger; desktop can wait for idle.
    if (isMobileHero()) {
      window.setTimeout(run, 120);
      return;
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 1800 });
    } else {
      window.setTimeout(run, 400);
    }
  }

  function initHero(section) {
    var bg = section.querySelector('.wudy-hero__bg--has-video');
    var video = section.querySelector('.wudy-hero__video');
    if (!bg || !video) return;

    // Poster-only when user asks for less motion or is on a very slow / data-saver link.
    // Mobile no longer skips video — load the light SD source instead.
    if (!connectionAllowsVideo()) {
      video.removeAttribute('src');
      video.querySelectorAll('source').forEach(function (s) {
        s.removeAttribute('src');
        s.removeAttribute('data-src');
      });
      try { video.load(); } catch (e) {}
      video.style.display = 'none';
      return;
    }

    scheduleLoad(bg, video);
  }

  function boot() {
    document.querySelectorAll('.wudy-home-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
